import UserHelper from 'general/helpers/UserHelper'
import { Outlet } from 'react-router-dom'
import { Navigate } from 'react-router-dom'
import GuestBaseLayout from '../eInvoiceComponents/BaseLayout/GuestBaseLayout'
import { DescriptionText, LoginHomeScreen, Title } from './style.js'
import { useHostname } from 'general/context/HostnameContext'
import BaseConfig from 'general/constants/DomainConfig'
import { GuestBaseFooter } from '../eInvoiceComponents/BaseLayout/GuestBaseFooter'

function GuestRoute() {
  const isAuth = UserHelper.checkAccessTokenValid()
  const hostname = useHostname()
  const bgHomeScreen = BaseConfig[hostname]?.introduceText?.background

  return !isAuth ? (
    <GuestBaseLayout nonPadding>
      <LoginHomeScreen bgHomeScreen={bgHomeScreen}>
        <div className="d-flex flex-column flex-lg-row justify-content-lg-between align-items-center">
          <div className="col-12 col-lg-7 d-flex flex-column justify-content-center">
            <Title>{BaseConfig[hostname]?.introduceText?.title}</Title>
            <DescriptionText>
              {BaseConfig[hostname]?.introduceText?.content}
            </DescriptionText>
          </div>
          <div className="col-11 py-10 py-lg-0 col-sm-8 col-lg-5 col-xxl-5 col-md-6">
            <Outlet />
          </div>
        </div>
      </LoginHomeScreen>
      {BaseConfig[hostname]?.footer?.isHadFooter && (
        <GuestBaseFooter contents={BaseConfig[hostname]?.footer?.content} />
      )}
    </GuestBaseLayout>
  ) : (
    <Navigate to="/" />
  )
}

export default GuestRoute
